const RECOVERABLE_GRID_ERROR_MESSAGES = [
    'The columnWidths property of the TableColumnResizing plugin is given an invalid value.',
    'Cannot read property \'map\' of undefined',
    'Cannot read properties of undefined (reading \'map\')',
    'Cannot read properties of null (reading \'offsetWidth\')',
    'Cannot read properties of null (reading \'offsetHeight\')',
];

const RECOVERABLE_GRID_ERROR_PATTERNS = [
    /^can't access property "offsetWidth", .* is null$/,
    /^can't access property "offsetHeight", .* is null$/,
    // Safari names the minified variable, which changes between builds.
    /^null is not an object \(evaluating '[\w$.]+\.offset(?:Width|Height)'\)$/,
];

const isRecoverableGridError = (error) => {
    const { message = '' } = error || {};
    return RECOVERABLE_GRID_ERROR_MESSAGES.includes(message)
        || RECOVERABLE_GRID_ERROR_PATTERNS.some((pattern) => pattern.test(message));
};

export default isRecoverableGridError;
